/*
 * @Description:自然人信息管理-->自然人/个体
 * @Date: 2022-09-19 14:37:49
 */
import http from '@/utils/http/axios';
import { wwwConfig } from '@/utils/http/axios/content-type';
import { Person, Product, TagType, Zs, ZsConfig, ZsEditType } from './types';
import {
  PRODUCT_TYPE_MAP,
  ROAD_APP_VALUE,
  ROAD_MINI_VALUE,
  ROAD_WEB_VALUE,
  STATUS_TYPE,
  PRESCRIPTION_TYPE_MAP,
  PUBLISH_SOURCE_MAP
} from '../config';

const yApiObj = {
  // yapi: 1271
};

enum Api {
  CONFIG_LIST = '/front-end/zs/config/list',
  CONFIG_GET = '/front-end/zs/config/get',
  CONFIG_SET = '/front-end/zs/config/save',
  CONFIG_PRODUCT_LIST = '/front-end/zs/config/productList',
  CONFIG_CITY_LIST = '/front-end/zs/config/provinceCity',
  CONFIG_STATUS = '/front-end/zs/config/status',
  CONFIG_COMPANY_LIST = '/front-end/zs/config/entSelectList',
  CONFIG_SET_TOP = '/front-end/zs/config/top',

  PRODUCT_LIST = '/front-end/zs/product/productList',
  PRODUCT_ADD = '/front-end/zs/product/saveProduct',
  PRODUCT_DEL = '/front-end/zs/product/deleteProduct',
  PRODUCT_UPDATE = '/front-end/zs/product/updateProduct',
  PRODUCT_OTHER_INFO = '/front-end/zs/product/productInfo',
  PRODUCT_UPLOAD = '/back-end/file/upload',

  TAG_LIST = '/front-end/zs/label/labelList',
  TAG_ADD = '/front-end/zs/label/saveLabel',
  TAG_DEL = '/front-end/zs/label/deleteLabel',
  TAG_UPDATE = '/front-end/zs/label/updateLabel',

  PEOPLE_PRODUCT_LIST = '/front-end/zs/peopleManage/queryProductList',
  PEOPLE_ENTERPRISE_LIST = '/front-end/zs/peopleManage/queryEnterpriseList',
  PEOPLE_TABLE_COLUMN = '/front-end/zs/peopleManage/queryTableColumn',
  PEOPLE_LIST = '/front-end/zs/peopleManage/queryPeopleList',
  PEOPLE_EXPORT = '/front-end/zs/peopleManage/exportPeopleList',
  PEOPLE_EXPORT_ALL = '/front-end/zs/peopleManage/exportPeopleListAll',
  commonUpload = '/back-end/file/upload',
  queryZsProtocol = '/front-end/zs/config/queryZsProtocol'
}

export const getConfigList = async (params: Zs['search']) => {
  const res = await http.request<
    Result<{ list: Array<Zs['row']>; total: number }>
  >(
    {
      url: Api.CONFIG_LIST,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
  return res;
};

export const getConfigProductList = async (
  params: {
    enterpriseId?: string | number;
    name?: string;
    type?: keyof typeof PRODUCT_TYPE_MAP; //产品类型：1-药品，2-器械；选填
    excludeIds?: Array<number | string>;
  } & GPaginationParams
) => {
  const res = await http.request(
    {
      url: Api.CONFIG_PRODUCT_LIST,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
  return res;
};

export const getConfigCityList = async () => {
  type City = { id: number; areaName: string; children: Array<City> };
  const res = await http.request<Result<Array<City>>>(
    {
      url: Api.CONFIG_CITY_LIST,
      method: 'POST'
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
  return res;
};
export const getConfigCompanyList = async (params: {
  selectType: 1 | 2;
  type?: keyof typeof PUBLISH_SOURCE_MAP;
  keyword?: string;
}) => {
  const res = await http.request<
    Result<
      Array<{ enterpriseId: number; enterpriseName: string; phone: string }>
    >
  >(
    {
      url: Api.CONFIG_COMPANY_LIST,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
  res.data.forEach(i => {
    i['value'] = i.enterpriseId;
    i['label'] = i.enterpriseName;
  });
  return res;
};

export const editConfig = async (params: ZsEditType) => {
  const res = await http.request<Result<number>>(
    {
      url: Api.CONFIG_SET,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
  return res;
};

export const getConfig = async (params?: { configId: number | string }) => {
  const res = await http.request<Result<ZsConfig>>(
    {
      url: Api.CONFIG_GET,
      method: 'GET',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
  if (res.data) {
    res.data['tags'] = res.data.labelList?.map(i => {
      const cityChooseMap = new Map();
      const item = {
        id: i.labelId,
        name: i.labelName,
        required: Boolean(i.isMustFill),
        isLocation: Boolean(i.isLocation),
        optionType: i.optionType,
        source: i.source,
        chooseTagValues: i.isLocation
          ? i.areaList.map(i => {
              cityChooseMap.set(i.provinceId, i.isAll);
              return [i.provinceId, i.cityId].filter(Boolean);
            })
          : i.optionList.filter(i => i.isChecked == 1).map(i => i.optionId),
        _provinceChooseAllMap: cityChooseMap,
        childList: i.optionList.map(j => ({
          id: j.optionId,
          name: j.optionName
        }))
      } as TagType;
      return item;
    });
    res.data['platforms'] = [];
    if (res.data.zsWebIsShow) res.data['platforms'].push(ROAD_WEB_VALUE);
    if (res.data.zsAppIsShow) res.data['platforms'].push(ROAD_APP_VALUE);
    if (res.data.zsWxIsShow) res.data['platforms'].push(ROAD_MINI_VALUE);
  }
  return res;
};

export const setConfigStatus = async (params: {
  configId: number;
  status: keyof typeof STATUS_TYPE;
  reason?: string;
  otcList?: Array<{
    productId: number;
    isOtc: keyof typeof PRESCRIPTION_TYPE_MAP;
  }>;
}) => {
  return await http.request<Result<keyof typeof STATUS_TYPE>>(
    {
      url: Api.CONFIG_STATUS,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};

export const setConfigTop = async (params: {
  configId: number;
  isTop: 0 | 1;
}) => {
  return await http.request<Result<any>>(
    {
      url: Api.CONFIG_SET_TOP,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};

export const getProductList = async (params: Product['search']) => {
  const res = await http.request<
    Result<{ list: Array<Product['row']>; total: number }>
  >(
    {
      url: Api.PRODUCT_LIST,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
  res.data?.list?.forEach(item => {
    ['name', 'productName', 'medicineType', 'jixing', 'guige', 'scope'].forEach(
      key => (item[key] = item[key] || '-')
    );
  });
  return res;
};
export const addProduct = async (params: Partial<Product['row']>) => {
  return await http.request(
    {
      url: Api.PRODUCT_ADD,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};
export const updateProduct = async (params: Partial<Product['row']>) => {
  return await http.request(
    {
      url: Api.PRODUCT_UPDATE,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};

export const deleteProduct = async (params: { id: number }) => {
  return await http.request(
    {
      url: Api.PRODUCT_DEL,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
};

export const uploadProductImg = async (params: { file: File }) => {
  const res = await http.uploadFile(
    {
      url: Api.PRODUCT_UPLOAD,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return res as Result<{ fileUrl: string }>;
};

export const getProductOtherInfo = async (params: {
  approvalNumber: number | string;
  type: Product['search']['type'];
}) => {
  return await http.request<Result<Product['row']>>(
    {
      url: Api.PRODUCT_OTHER_INFO,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
};

export const getTagList = async (params?: {
  enterpriseId: number | string;
}) => {
  return await http.request<Result<Array<TagType>>>(
    {
      url: Api.TAG_LIST,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
};
export const addTag = async (params: {
  enterpriseId?: string | number;
  name: string;
  childLabelList: Array<string>;
  optionType: TagType['optionType'];
}) => {
  return await http.request(
    {
      url: Api.TAG_ADD,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};
export const updateTag = async (params: {
  enterpriseId?: string | number;
  id: TagType['id'];
  name: string;
  childLabelList: Array<string>;
  optionType: TagType['optionType'];
}) => {
  return await http.request(
    {
      url: Api.TAG_UPDATE,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};

export const deleteTag = async (params: { id: TagType['id'] }) => {
  return await http.request(
    {
      url: Api.TAG_DEL,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
};

export const getPeopleProductList = async (params: {
  productName?: string;
  enterpriseId?: string;
}) => {
  const res = await http.request<
    Result<
      Array<{
        productId: number;
        productName: string;
        value: number;
        label: string;
      }>
    >
  >(
    {
      url: Api.PEOPLE_PRODUCT_LIST,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
  res.data.forEach(i => {
    i['value'] = i.productId;
    i['label'] = i.productName;
  });
  return res;
};

export const getPeopleEnterpriseList = async (params?: {
  productName?: string;
}) => {
  const res = await http.request<
    Result<
      Array<{
        enterpriseId: number;
        enterpriseName: string;
        phone: string;
        value: number;
        label: string;
      }>
    >
  >(
    {
      url: Api.PEOPLE_ENTERPRISE_LIST,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
  res.data.forEach(i => {
    i['value'] = i.enterpriseId;
    i['label'] = `${i.enterpriseName}${i.phone ? `(${i.phone})` : ''}`;
  });
  return res;
};

export const getTableColumnList = async (params?: {
  enterpriseId?: string;
}) => {
  return await http.request<
    Result<Array<{ isFix: 0 | 1; name: string; nameCh: string }>>
  >({ url: Api.PEOPLE_TABLE_COLUMN, method: 'POST', params });
};

export const getPeopleList = async (params: Person['search']) => {
  return await http.request<
    Result<{ list: Array<Person['row']>; total: number }>
  >(
    {
      url: Api.PEOPLE_LIST,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      ...yApiObj
    }
  );
};

export const peopleExport = async params => {
  return http.download({
    url: Api.PEOPLE_EXPORT,
    method: 'POST',
    params
  });
};
export const peopleExportAll = async params => {
  return http.download({
    url: Api.PEOPLE_EXPORT_ALL,
    method: 'POST',
    params
  });
};

//logo
export const autoUploadImge: (params) => Promise<Result> = async params => {
  console.log('paramsApi', params);
  const respond = await http.uploadFile(
    {
      url: Api.commonUpload,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return respond as unknown as Result;
};

export const queryZsProtocol = async () => {
  return await http.request<Result<any>>(
    {
      url: Api.queryZsProtocol,
      method: 'GET'
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
};
